import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../lib/auth';

interface RequireAdminProps {
  children: React.ReactNode;
}

/**
 * Route guard: redirects unauthenticated users to /login (preserving the
 * intended path in router state). While the auth check is in flight, shows
 * a minimal spinner that matches the Signal aesthetic.
 */
const RequireAdmin: React.FC<RequireAdminProps> = ({ children }) => {
  const { user, isAdmin, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div
        style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'var(--bg, #000)',
        }}
      >
        <span
          style={{
            display: 'inline-block',
            width: 20,
            height: 20,
            borderRadius: '50%',
            border: '2px solid var(--accent, #00d4aa)',
            borderTopColor: 'transparent',
            animation: 'spin 0.8s linear infinite',
          }}
        />
      </div>
    );
  }

  if (!user || !isAdmin) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default RequireAdmin;
